import { TYPES } from "./draft_dialog.type";
import {
  getDocs,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getApiFunctions } from "store/bailiff/api";
import { getApp } from "firebase/app";

const app = getApp();
const bucket = "gs://vi-viet-nam-bailiff-draft";
const storage = getStorage(app, bucket);
const auth = getAuth(app);

// ========= firebase function =========//
//snap all provider
const allDraftDialogSub = [];
export const snapDraftDialog = (callback) => (dispatch) => {
  setDraftDialogDetailSuccess(dispatch, null);
  const cRef = getRefs().dialog;
  const uid = auth?.currentUser?.uid;
  const c0 = where("takeOverBy", "==", uid);
  const c1 = where("status", "==", "working");
  const qRef = query(cRef, c0, c1);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      const detail = data?.length > 0 ? data[0] : null;
      setDraftDialogDetailSuccess(dispatch, detail);
      if (callback) {
        callback();
      }
    }
  });
  allDraftDialogSub.push(unsub);
};

export const unSnapDraftDialog = () => (dispatch) => {
  allDraftDialogSub.forEach((subscriber) => {
    subscriber();
  });
  allDraftDialogSub.length = 0;
};

// snap last draft dialog
const draftDialogSub = [];
export const snapDraftDialogLastCount = () => (dispatch) => {
  setDraftDialogRentTaskSuccess(dispatch, 0);
  const cRef = getRefs().dialog;
  const c0 = where("status", "==", "supporting");
  const c1 = where("takeOverBy", "==", "none");
  const c2 = orderBy("createAt", "desc");
  const c3 = limit(1);
  const qRef = query(cRef, c0, c1, c2, c3);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      const count = data?.length || 0;
      setDraftDialogRentTaskSuccess(dispatch, count);
    }
  });

  draftDialogSub.push(unsub);
};

export const unSnapDraftDialogLastCount = () => (dispatch) => {
  draftDialogSub.forEach((subscriber) => {
    subscriber();
  });
  draftDialogSub.length = 0;
};

// get dialog by id.
export const getDialogById =
  ({ id }, callback) =>
  (dispatch) => {
    const cRef = getRefs().dialog;
    const uid = auth?.currentUser?.uid;
    const c0 = where("takeOverBy", "==", uid);
    const c1 = where("id", "==", id);
    const qRef = query(cRef, c0, c1);
    getDocs(qRef)
      .then((snapshot) => {
        if (snapshot) {
          const data = snapshot?.docs?.map((doc) => doc?.data());
          const detail = data?.length > 0 ? data?.[0] : null;
          callback && callback(detail);
        } else {
          callback && callback(null);
        }
      })
      .catch((err) => {
        console.log({ err });
        callback && callback(null);
      });
  };

// ========= cloud function =========//

// ::::: các tác vụ riêng cho supporter :::::://
export const takeTask = (callback) => async (dispatch) => {
  const functions = getApiFunctions().dialog.draftDialogTakeOver;
  const options = {};
  try {
    await functions(options);
    callback && callback({ status: 200 });
  } catch (err) {
    callback &&
      callback({ status: 500, data: err?.message || "Error ! Invalids" });
  }
};

export const leaveTask = (callback) => async (dispatch) => {
  const functions = getApiFunctions().dialog.draftDialogLeaveTask;
  const options = {};
  try {
    await functions(options);
    callback && callback({ status: 200 });
  } catch (err) {
    callback &&
      callback({ status: 500, data: err?.message || "Error ! Invalids" });
  }
};

export const updateSegment =
  ({ update }, callback) =>
  async (dispatch) => {
    const functions = getApiFunctions().dialog.draftDialogUpdateSentence;
    const options = update;
    try {
      await functions(options);
      callback && callback({ status: 200 });
    } catch (err) {
      callback &&
        callback({ status: 500, data: err?.message || "Error ! Invalids" });
    }
  };

export const completeTask = (callback) => async (dispatch) => {
  const functions = getApiFunctions().dialog.draftDialogCompleteTask;
  const options = {};
  try {
    await functions(options);
    callback && callback({ status: 200 });
  } catch (err) {
    callback &&
      callback({ status: 500, data: err?.message || "Error ! Invalids" });
  }
};
// ========= storage =========//
export const getAudioUrl =
  ({ bailiff, part }) =>
  (dispatch) => {
    setDraftDialogAudioUrlSuccess(dispatch, null);
    const path = `bailiff/audio/${bailiff}/parts/${part}.mp3`;
    const storageRef = ref(storage, path);
    getDownloadURL(storageRef)
      .then((url) => {
        console.log({ url });
        setDraftDialogAudioUrlSuccess(dispatch, url);
      })
      .catch((err) => {
        console.log({ err });
      });
  };

// ========= local function =========//
export const setDraftDialogAll = (data, callback) => (dispatch) => {
  setDraftDialogAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogOpenAdd = (data, callback) => (dispatch) => {
  setDraftDialogOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogOpenEdit = (data, callback) => (dispatch) => {
  setDraftDialogOpenEditSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSelected = (data, callback) => (dispatch) => {
  setDraftDialogSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSearch = (data, callback) => (dispatch) => {
  setDraftDialogSearchSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogIndex = (data, callback) => (dispatch) => {
  setDraftDialogIndexSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogPlay = (data, callback) => (dispatch) => {
  setDraftDialogPlaySuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSecond = (data, callback) => (dispatch) => {
  setDraftDialogSecondSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDraftDialogSelectedRange = (data, callback) => (dispatch) => {
  setDraftDialogSelectedRangeSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const resetTaskVariable = () => (dispatch) => {
  setDraftDialogIndexSuccess(dispatch, 0);
  setDraftDialogPlaySuccess(dispatch, false);
  setDraftDialogSecondSuccess(dispatch, 0);
  setDraftDialogAudioUrlSuccess(dispatch, null);
  setDraftDialogSelectedRangeSuccess(dispatch, {
    start: 0,
    end: 0,
  });
};

// ========= dispatch =========//

const setDraftDialogAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_ALL,
    payload: data,
  });
};

const setDraftDialogOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_OPEN_ADD,
    payload: data,
  });
};

const setDraftDialogOpenEditSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_OPEN_EDIT,
    payload: data,
  });
};

const setDraftDialogSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SELECTED,
    payload: data,
  });
};

const setDraftDialogSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SEARCH,
    payload: data,
  });
};

const setDraftDialogDetailSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_DETAIL,
    payload: data,
  });
};

const setDraftDialogIndexSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_INDEX,
    payload: data,
  });
};

const setDraftDialogPlaySuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_PLAY,
    payload: data,
  });
};

const setDraftDialogSecondSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SECOND,
    payload: data,
  });
};

const setDraftDialogAudioUrlSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_AUDIO_URL,
    payload: data,
  });
};

const setDraftDialogSelectedRangeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_SELECTED_RANGE,
    payload: data,
  });
};

const setDraftDialogRentTaskSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DRAFT_DIALOG_RENT_TASK,
    payload: data,
  });
};
